import type { StudentAttributes } from '@backend/resources/student/types'
import type { UpdateStudentResponse } from '@backend/students-api/routes/students/PATCH/types'

import { ApiStudentRequest, request } from '../utils'

import { useAuthMutation } from './auth'

type UpdateStudentParams = {
  id: string
  attributes?: StudentAttributes
}

export function useUpdateStudent() {
  const { isPending, mutate } = useAuthMutation(async (params: UpdateStudentParams) => {
    return request<UpdateStudentResponse>(
      new ApiStudentRequest('/students', {
        method: 'PATCH',
        body: {
          data: {
            id: params.id,
            type: 'student',
            attributes: params.attributes,
          },
        },
      }),
      {
        isExpectedResponse: (res): res is UpdateStudentResponse => res as boolean,
      },
    )
  })

  return {
    isUpdatingStudent: isPending,
    updateStudent: mutate,
  }
}
